import { render, staticRenderFns } from "./gdmap.vue?vue&type=template&id=654be99e"
import script from "./gdmap.vue?vue&type=script&lang=js"
export * from "./gdmap.vue?vue&type=script&lang=js"
import style0 from "./gdmap.vue?vue&type=style&index=0&id=654be99e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports